/**
 * Debug Toggle Button
 *
 * A floating button to toggle component visualization on/off with depth slider.
 */

import { useDebug } from "./DebugContext";
import { FaBug, FaTimes, FaLayerGroup } from "react-icons/fa";

const DebugToggle = ({ position = "fixed", style = {} }) => {
  let isDebugMode = false;
  let toggleDebug = () => {};
  let depthLevel = 0;
  let setDepthLevel = () => {};
  let maxDepth = 20;

  try {
    const debug = useDebug();
    isDebugMode = debug.isDebugMode;
    toggleDebug = debug.toggleDebug;
    depthLevel = debug.depthLevel;
    setDepthLevel = debug.setDepthLevel;
    maxDepth = debug.maxDepth || 20;
  } catch (error) {
    console.error("DebugToggle: Failed to get debug context", error);
    // Render anyway with defaults
  }

  const defaultStyle = {
    position,
    bottom: "20px",
    right: "20px",
    zIndex: 1000000,
    ...style,
  };

  const handleClick = () => {
    console.log("[Debug] Button clicked, current mode:", isDebugMode);
    toggleDebug();
  };

  return (
    <div className="debug-toggle-container" style={defaultStyle}>
      <button
        onClick={handleClick}
        className={`debug-toggle ${isDebugMode ? "debug-toggle--active" : ""}`}
        title={
          isDebugMode
            ? "Hide component borders (⌘⇧B)"
            : "Show component borders (⌘⇧B)"
        }
        aria-label={isDebugMode ? "Disable debug mode" : "Enable debug mode"}
      >
        {isDebugMode ? (
          <>
            <FaTimes /> Debug ON
          </>
        ) : (
          <>
            <FaBug /> Debug
          </>
        )}
      </button>
      
      {isDebugMode && (
        <div className="debug-depth-control">
          <label>
            <FaLayerGroup />
            <span>Level {depthLevel}</span>
          </label>
          <input
            type="range"
            min="0"
            max={maxDepth}
            value={depthLevel}
            onChange={(e) => setDepthLevel(Number(e.target.value))}
            className="debug-slider"
          />
        </div>
      )}
    </div>
  );
};

export default DebugToggle;
